import TagControl from './TagControl';
export * from './TagControl';

export default TagControl;
